import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './File.styles';

export interface FileIconProps extends WithStyles<typeof styles> {
  color?: string;
}

const FileIconComponent: FC<FileIconProps> = ({ classes, color = '#7E8899' }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      classes={{ root: classes.root }}
    >
      <path
        d="M9.33366 1.51314V4.26683C9.33366 4.6402 9.33366 4.82688 9.40632 4.96949C9.47024 5.09493 9.57222 5.19692 9.69766 5.26083C9.84027 5.3335 10.027 5.3335 10.4003 5.3335H13.154M13.3337 6.65898V11.4668C13.3337 12.5869 13.3337 13.147 13.1157 13.5748C12.9239 13.9511 12.618 14.2571 12.2416 14.4488C11.8138 14.6668 11.2538 14.6668 10.1337 14.6668H5.86699C4.74689 14.6668 4.18683 14.6668 3.75901 14.4488C3.38269 14.2571 3.07673 13.9511 2.88498 13.5748C2.66699 13.147 2.66699 12.5869 2.66699 11.4668V4.5335C2.66699 3.41339 2.66699 2.85334 2.88498 2.42552C3.07673 2.04919 3.38269 1.74323 3.75901 1.55148C4.18683 1.3335 4.74689 1.3335 5.86699 1.3335H8.00818C8.49736 1.3335 8.74195 1.3335 8.97212 1.38876C9.17619 1.43775 9.37128 1.51856 9.55023 1.62822C9.75206 1.7519 9.92501 1.92485 10.2709 2.27075L12.3964 4.39624C12.7423 4.74214 12.9153 4.91509 13.0389 5.11693C13.1486 5.29587 13.2294 5.49096 13.2784 5.69503C13.3337 5.92521 13.3337 6.1698 13.3337 6.65898Z"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FileIcon = withStyles(styles)(FileIconComponent);
